import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=b85d9fb0&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85d9fb0",
  null
  
)

export default component.exports